// extracted by mini-css-extract-plugin
export var menuIcon = "_m2-0";
export var menuIconInline = "_m2-1";